import { CommonModule, DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Component, Inject, Input, OnInit, PLATFORM_ID } from "@angular/core";

@Component({
  selector: "app-trust-pilot",
  templateUrl: "./trust-pilot.component.html",
  styleUrls: ["./trust-pilot.component.scss"],
  imports: [CommonModule],
})
export class TrustPilotComponent implements OnInit {
    @Input() bgWhite: boolean = false;
    @Input() paddTop: boolean = false;
    isBrowser: boolean = false;
    
    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    ngOnInit(): void {
        if (this.isBrowser) {
            // this.loadTrustpilotScript();
        }
    }
  //   loadTrustpilotScript() {
  //   // Only load script in browser environment
  //   if (!isPlatformBrowser(this.platformId)) {
  //     return;
  //   }

  //   const script = this.document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.async = true;
  //   script.src =
  //     'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  //   this.document.head.appendChild(script);
  //   script.onload = () => {
  //     // Add timeout to ensure DOM is ready and initialize Trustpilot widget
  //     setTimeout(() => {
  //       // @ts-ignore - Trustpilot global object
  //       if (typeof window !== 'undefined' && window.Trustpilot) {
  //         // @ts-ignore
  //         window.Trustpilot.loadFromElement(this.document.querySelector('.trustpilot-widget'), true);
  //       }
  //     }, 500);
  //   };
    
  //   script.onerror = () => {
  //     console.warn('Failed to load Trustpilot script');
  //   };
  // }
}